import React, { useState, useEffect } from 'react';
import TabView from './components/TabView';
import TableView from './components/TableView';
import CardView from './components/CardView';

const App = () => {
  const [servers, setServers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState('card');

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      });
    } catch (e) {
      console.error('Date formatting error:', e);
      return 'N/A';
    }
  };

  useEffect(() => {
    const fetchServers = async () => {
      try {
        console.log('Starting fetch request...');
        const response = await fetch('/servers');
        console.log('Response received:', response.status);

        if (!response.ok) {
          const text = await response.text();
          console.error('Error response:', text);
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        console.log('Data received:', data);

        if (!data || !data.servers) {
          console.error('Invalid data format:', data);
          throw new Error('Invalid data format received');
        }

        const mappedServers = data.servers.map(server => ({
          server_name: server.name,
          released_on: formatDate(server.created_at || server.updated_at),
          github_stars: server.github_stars || 0,
          package_registry: server.package_registry || 'N/A',
          package_name: server.package_name || 'N/A',
          package_download_count: server.package_download_count || 0,
          description: server.short_description || server.EXPERIMENTAL_ai_generated_description || 'No description available',
          url: server.source_code_url || server.external_url || server.url,
          source_code_url: server.source_code_url,
          external_url: server.external_url
        }));

        setServers(mappedServers);
        setError(null);
      } catch (err) {
        console.error('Error fetching servers:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchServers();
  }, []);

  if (loading) {
    return (
      <div className="container" style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto' }}>
        <h1><img src="/icon.png" alt="MCP Icon" style={{ height: '32px', marginRight: '10px', verticalAlign: 'middle' }} />MCP Servers</h1>
        <div style={{ 
          padding: '20px',
          textAlign: 'center',
          color: '#666'
        }}>
          Loading servers...
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container" style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto' }}>
        <h1><img src="/icon.png" alt="MCP Icon" style={{ height: '32px', marginRight: '10px', verticalAlign: 'middle' }} />MCP Servers</h1>
        <div style={{ 
          padding: '20px',
          backgroundColor: '#fee2e2',
          border: '1px solid #dc2626',
          borderRadius: '8px',
          color: '#dc2626',
          marginTop: '20px'
        }}>
          <div><strong>Error loading servers:</strong> {error}</div>
          <div style={{ marginTop: '10px', fontSize: '0.9em', color: '#666' }}>
            Please try refreshing the page. If the problem persists, check the browser console for more details.
          </div>
        </div>
      </div>
    );
  }

  const tabs = [
    {
      id: 'card',
      label: 'Card View',
      content: <CardView servers={servers} />
    },
    {
      id: 'table',
      label: 'Table View',
      content: <TableView servers={servers} />
    }
  ];

  return (
    <div className="container">
      <h1><img src="/icon.png" alt="MCP Icon" style={{ height: '32px', marginRight: '10px', verticalAlign: 'middle' }} />MCP Servers</h1>
      <TabView 
        tabs={tabs}
        activeTab={activeTab}
        onTabChange={setActiveTab}
      />
    </div>
  );
};

export default App;
